import { Syncable } from "shared/state/models/syncable";
import { IMatingBatch } from "shared/api/api";


export const SAVE_MATING_BATCHES = 'SAVE_MATING_BATCHES';
export const SYNC_DATA_MATINGBATCH = 'SYNC_DATA_MATINGBATCH';
export const DELETE_MATING_BATCHES_BY_DATE = 'DELETE_MATING_BATCHES_BY_DATE'

export interface MatingBatchState extends Syncable<IMatingBatch> {}
